<cwo-ordering-calendar
    [deferDateInput]="deferDateInput()"
    [deferredDayTimes]="deferredDayTimes()"
    (dateSelected)="handleSelectedDate($event)"
    (storeClosedForSelectedDate)="storeClosedForSelectedDate.emit($event)"
/>
